import React from "react";

export default function LeadTable({
  isLoading,
  limit,
  page,
  currentData,
  onEdit,
  onRepeat,
  onDelete,
}) {
  return (
    <div className="table-responsive mt-3" style={{ fontSize: "0.9rem" }}>
      <table className="table table-bordered table-hover align-middle">
        <thead className="bg-light">
          <tr>
            <th scope="col">#</th>
            <th scope="col" className="text-start">
              Name
            </th>
            <th scope="col" className="text-start">
              Phone No.
            </th>
            <th scope="col">Status</th>
            <th scope="col" style={{ width: 120 }}>Contact</th>
            <th scope="col" style={{ width: 120 }}>Actions</th>
          </tr>
        </thead>
        <tbody>
          {isLoading ? (
            Array.from({ length: limit }).map((_, i) => (
              <tr key={i}>
                <td>
                  <div className="skeleton-box" style={{ height: "15px" }}></div>
                </td>
                <td>
                  <div className="skeleton-box" style={{ height: "15px" }}></div>
                </td>
                <td>
                  <div className="skeleton-box" style={{ height: "15px" }}></div>
                </td>
                <td>
                  <div className="skeleton-box" style={{ height: "15px" }}></div>
                </td>
                <td>
                  <div
                    className="skeleton-box"
                    style={{ height: "25px", width: "80px", margin: "auto" }}
                  ></div>
                </td>
              </tr>
            ))
          ) : currentData.length > 0 ? (
            currentData.map((lead, idx) => (
              <tr key={lead.id}>
                <th scope="row">{(page - 1) * limit + idx + 1}</th>
                <td className="text-start">{lead.name}</td>
                <td className="text-start">
                  +{lead.country}
                  {lead.phone}
                </td>
                <td>{lead.status}</td>
                <td>
                  <div className="d-flex gap-2 justify-content-end">
                    <a
                      className="btn btn-sm btn-success"
                      target="_blank"
                      rel="noreferrer"
                      href={`https://api.whatsapp.com/send?phone=${lead.country + lead.phone}`}
                      title="WhatsApp"
                    >
                      <i className="bi bi-whatsapp"></i>
                    </a>

                    <a href={`tel:${lead.country + lead.phone}`} className="btn btn-sm btn-primary"><i className="bi bi-phone"></i></a>

                  </div>
                </td>
                <td>
                  <div className="d-flex gap-2 justify-content-end">

                  {lead.status === "Closed" && (
                      <button
                        className="btn btn-sm btn-light"
                        onClick={() => onRepeat(lead.id)}
                        title="Repeat Sale"
                      >
                        <i className="bi bi-arrow-repeat"></i>
                      </button>
                    )}

                    <button className="btn btn-sm btn-light" onClick={() => onEdit(lead.id)}>
                      <i className="bi bi-pencil-fill"></i>
                    </button>

                    <button
                      className="btn btn-sm btn-danger"
                      data-bs-toggle="modal"
                      data-bs-target="#deleteDB"
                      onClick={() => onDelete(lead.id)}
                      title="Delete"
                    >
                      <i className="bi bi-trash"></i>
                    </button>
                  </div>
                </td>
              </tr>
            ))
          ) : (
            <tr>
              <td colSpan="5" className="text-center text-muted">
                No leads found.
              </td>
            </tr>
          )}
        </tbody>
      </table>
    </div>
  );
}
